import { ZERO } from './const.js';

export function isPositive(value: number) {
  return value > ZERO;
}
